// Path-based i18n helpers.
// Dutch (nl) is the default language and lives on the clean URLs (/, /shop, ...).
// en / fr / de live under a path prefix (/en, /fr, /de). These helpers drive the
// React Router basename, SEO canonicals, hreflang alternates and the language switcher.
export const LANGS = ["nl", "en", "fr", "de"];
export const DEFAULT_LANG = "nl";
export const PREFIXED_LANGS = ["en", "fr", "de"];

// Detect the active language from a full pathname ("/fr/shop" -> "fr", "/shop" -> "nl").
export function langFromPath(pathname = "/") {
  const seg = (pathname || "/").split("/")[1];
  return PREFIXED_LANGS.includes(seg) ? seg : DEFAULT_LANG;
}

// React Router basename for a language ("/" for nl, "/fr" for the others).
export function basenameForLang(lang) {
  return lang && lang !== DEFAULT_LANG ? `/${lang}` : "/";
}

// Strip the language prefix -> clean path ("/fr/shop" -> "/shop", "/fr" -> "/").
export function stripLangPrefix(pathname = "/") {
  const parts = (pathname || "/").split("/");
  if (PREFIXED_LANGS.includes(parts[1])) {
    const rest = "/" + parts.slice(2).join("/");
    return rest === "/" ? "/" : rest.replace(/\/+$/, "");
  }
  return pathname || "/";
}

// Build a language-prefixed path from a clean path ("/shop","fr" -> "/fr/shop").
export function localizedPath(cleanPath = "/", lang = DEFAULT_LANG) {
  const clean = cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`;
  if (!lang || lang === DEFAULT_LANG) return clean;
  return clean === "/" ? `/${lang}` : `/${lang}${clean}`;
}

// Switch the UI language: remember the explicit choice, then navigate (full page
// load) to the language-prefixed equivalent of the current URL so the router
// basename + prerendered page for that language are served correctly.
export function switchLanguage(code) {
  try { localStorage.setItem("kann_lang_pref", code); } catch (e) { /* noop */ }
  const clean = stripLangPrefix(window.location.pathname);
  const target = localizedPath(clean, code) + window.location.search + window.location.hash;
  const current = window.location.pathname + window.location.search + window.location.hash;
  if (target !== current) window.location.assign(target);
}
